import React ,{useState} from 'react';
import {completeTask} from "../../store/action/taskAction";
import {useDispatch} from "react-redux";
import { useNavigate } from 'react-router-dom';
import { Padding, PaidRounded } from '@mui/icons-material';

const ValidationButton = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate(); //the problem is that /sidenav is also used for all tasks + todolist
    const [loading, setLoading] = useState(false);

    const containerStyle = {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '100%',
        height: '90px',
        position: 'absolute',
        //top: '810px',
        left: '0px', 
        opacity: '0px',
        //border: '1px solid rgba(229, 234, 238, 1)'
        marginTop :'15px',
        paddingRight : '40px'
    };

    const commonButtonStyle = {
        fontFamily: 'Poppins',
        fontSize: '10.76px',
        fontWeight: 600, 
        border: 'none',
        cursor: 'pointer',
        opacity: '0px',
        borderRadius: '5.38px', 
    };

    const annulerStyle = {
        ...commonButtonStyle,
        width: '83px',
        height: '36px',
        backgroundColor: 'rgba(229, 234, 238, 1)',
        color: 'rgba(128, 128, 143, 1)', 
        marginRight : '20px'
    };

    const validerStyle = {
        ...commonButtonStyle,
        width: '83px',
        height: '36px',
        backgroundColor: 'rgba(60, 101, 86, 1)',
        color: 'rgba(255, 255, 255, 1)',  
        marginRight : '40px'
    };

    const handleValidationClick = async () => {
        setLoading(true); // Active l'état de chargement
        await props.handleValidation(); // Exécute la fonction
        setLoading(false); // Désactive l'état de chargement
    };

    const handleAnnulation = () => {
        //window.history.back();
       navigate('/todo-list', { reload: true });
    };

    return (
        <div style={containerStyle}>
            <button style={annulerStyle} onClick={handleAnnulation}  disabled={loading}>Annuler</button>
            <button style={validerStyle} onClick={handleValidationClick}  disabled={loading}>Valider</button>
            {loading ?
            <div
            style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",  // Center vertically
            }}
        >
            <div
            style={{
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
                textAlign: "center",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                display: "flex",           // Use flexbox
                flexDirection: "column",   // Stack the loader and text vertically
                justifyContent: "center",  // Vertically center content inside the box
                alignItems: "center",      // Horizontally center content inside the box
            }}
            >
            <div className="spinner" style={{ marginBottom: "10px" }}></div>  {/* Optional margin between loader and text */}
            <p style={{ fontFamily: "Poppins", fontSize: "16px", margin: 0 }}>
                Veuillez patienter...
            </p>
            </div>
        </div> :<></>}
        </div>
    );
};

export default ValidationButton;
